import React from "react";
import Button from "@mui/material/Button";
import { string, bool, func, node } from "prop-types";

const FormButton = ({
  variant = "contained",
  component = "button",
  // MUI's ButtonBase rewrites an undefined `type` to "button" whenever it
  // renders a real <button>, so a form built out of these had no submitter
  // at all and the browser refused to submit it on Enter. Accepting the prop
  // is what lets Form mark its Submit control as one; the default keeps
  // every other FormButton exactly as it renders today.
  type = "button",
  size = "medium",
  color = "primary",
  onClick,
  disabled = false,
  node,
  // An icon-only control has no text to be read out, so it needs a name.
  ariaLabel,
}) => {
  return (
    <Button
      variant={variant}
      component={component}
      size={size}
      color={color}
      // Only a real <button> may carry `type`. The cancel and reset controls
      // are component="div", and ButtonBase spreads `type` before it decides
      // whether the element is a button — so passing it unconditionally
      // emitted <div type="button">: inert, but invalid HTML.
      type={component === "button" ? type : undefined}
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel}
      fullWidth
    >
      {node}
    </Button>
  );
};
FormButton.propTypes = {
  variant: string.isRequired,
  component: string.isRequired,
  size: string.isRequired,
  color: string.isRequired,
  onClick: func,
  type: string,
  disabled: bool.isRequired,
  node: node.isRequired,
  ariaLabel: string,
};
FormButton.defaultProps = {
  variant: "contained",
  component: "button",
  type: "button",
  size: "medium",
  color: "primary",
  disabled: false,
};

export default React.memo(FormButton);
